import { Component } from "@angular/core";

@Component({
    selector: "pl-action-footer",
    templateUrl: "./action-footer.component.html",
    styleUrls: ["./action-footer.component.scss"],
    standalone: false
})
export class ActionFooterComponent {}
